import chatService from '../services/chatService';
import { useChatStore } from '../store/chatStore';

export const OLDER_PAGE_LIMIT = 50;

/**
 * Fetch one page of history older than `beforeSeq` and fold it into the
 * channel's buffer — the network + store half of ChatMessageView's
 * scroll-to-top paging, shared with jump-to-message (useJumpToMessage).
 *
 * `beforePrepend` runs only when the page has rows, immediately before they
 * are prepended: the scroll-anchoring caller captures its restore offset
 * there, exactly where it used to. Throws what `getMessages` throws.
 *
 * Returns { count, exhausted } — `exhausted` is true for a short page (the
 * start of history, or of what the plan serves).
 */
export async function loadOlderPage(channelId, beforeSeq, limit = OLDER_PAGE_LIMIT, { beforePrepend } = {}) {
  const older = await chatService.getMessages(channelId, { beforeSeq, limit });
  const store = useChatStore.getState();
  // A short (or empty) page means we've reached the start of history —
  // mark the channel exhausted so we stop firing requests at the top.
  const exhausted = older.length < limit;
  if (exhausted) {
    // Paging has stopped, so this really is the end of what the user
    // can read — which is when the plan-window notice may appear.
    store.noteHistoryEnd(channelId, true);
  }
  // ...or the start of what this PLAN serves. Same stop, different
  // reason, and the user is owed the difference: the messages above
  // are still there, this account may simply not read them.
  store.noteHistoryWindow(channelId, older.historyDays);
  if (older.length) {
    beforePrepend?.();
    useChatStore.getState().prependMessages(channelId, older);
  }
  return { count: older.length, exhausted };
}
